import {css} from 'lit'; export default css`.hotkey-section-list{list-style:none;padding:0}.hotkey-section-list li{margin:12px 0}`;
    